import {inject, Injectable, LOCALE_ID, PLATFORM_ID} from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import {isPlatformBrowser} from "@angular/common";

export type SEO_DATA = {
  title: string;
  description: string;
  image?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PageMetaService {
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);
  private readonly localeId = inject(LOCALE_ID);
  private readonly platformId = inject(PLATFORM_ID);

  public setTitleAndDescription({title, description, image}: SEO_DATA) {
    // Title
    if (title) {
      title = title.replace(/<[^>]*>/g, '');
      this.title.setTitle(title);
      this.meta.updateTag({ property: 'og:title', content: title });
      this.meta.updateTag({ name: 'twitter:title', content: title });
    }

    // Description
    if (description) {
      description = description.replace(/<[^>]*>/g, '');
      this.meta.updateTag({ name: 'description', content: description });
      this.meta.updateTag({ property: 'og:description', content: description });
      this.meta.updateTag({ name: 'twitter:description', content: description });
    }

    // Image
    if (image) {
      this.meta.updateTag({ property: 'og:image', content: image });
      this.meta.updateTag({ name: 'twitter:image', content: image });
    }

    // URL
    if (isPlatformBrowser(this.platformId)) {
      const currentUrl = window.location.href;
      this.meta.updateTag({ property: 'og:url', content:  currentUrl});
      this.meta.updateTag({ name: 'twitter:url', content: currentUrl });
    }

    // Type
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ name: 'twitter:card', content: 'summary' });

    // Site Name
    this.meta.updateTag({ property: 'og:site_name', content: 'Car For Ukraine' });

    // Twitter
    this.meta.updateTag({ name: 'twitter:site', content: '@carforukraine' });
    this.meta.updateTag({ name: 'twitter:creator', content: '@carforukraine' });

    // Language
    this.meta.updateTag({ property: 'og:locale', content: this.localeId });

  }
}
